module.exports = __webpack_public_path__ + "media/images/sports_coaching/card-desktop-35b0dbbe034ba81804fbb848d9e382a4.jpg";